export default __webpack_public_path__ + "static/media/About_BG-07.16a27471.png";